var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavDocumentSets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.15119 3.2C2.99045 3.2 2.8363 3.26321 2.72264 3.37574C2.60898 3.48826 2.54513 3.64087 2.54513 3.8V12.2C2.54513 12.3591 2.60898 12.5117 2.72264 12.6243C2.8363 12.7368 2.99045 12.8 3.15119 12.8H12.8482C13.0089 12.8 13.1631 12.7368 13.2767 12.6243C13.3904 12.5117 13.4542 12.3591 13.4542 12.2V5.6C13.4542 5.44087 13.3904 5.28826 13.2767 5.17574C13.1631 5.06321 13.0089 5 12.8482 5H7.39361C7.19098 5 7.00174 4.89974 6.88934 4.73282L5.85714 3.2H3.15119ZM1.86554 2.52721C2.20652 2.18964 2.66898 2 3.15119 2H6.18149C6.38413 2 6.57336 2.10026 6.68577 2.26718L7.71797 3.8H12.8482C13.3304 3.8 13.7928 3.98964 14.1338 4.32721C14.4748 4.66477 14.6663 5.12261 14.6663 5.6V12.2C14.6663 12.6774 14.4748 13.1352 14.1338 13.4728C13.7928 13.8104 13.3304 14 12.8482 14H3.15119C2.66898 14 2.20652 13.8104 1.86554 13.4728C1.52457 13.1352 1.33301 12.6774 1.33301 12.2V3.8C1.33301 3.32261 1.52457 2.86477 1.86554 2.52721Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDocumentSets);
export default __webpack_public_path__ + "static/media/nav-document-sets.dfffcc55c82fb0da60dfd414a4f4f5f8.svg";
export { ForwardRef as ReactComponent };